
import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Card } from 'react-bootstrap';
import { crearDatos, actualizarDatos, getDataList } from '../../api/common';
import { listarImpuestosContables } from '../../services/Impuestos/ImpuestosEndpoint';

export const ListadoImpuestos = () => {
  const [impuestos, setImpuestos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [taxescontable, setTaxesContable] = useState([]); // Para almacenar los impuestos configurados en el sistema contable
  const [hayImpuestosContable, setHayImpuestosContable] = useState(false); // Para indicar si hay impuestos configurados en el sistema contable
  const [paginaActual, setPaginaActual] = useState(1); // Para paginar los impuestos contables

  console.log('Impuestos del sistema contable:', taxescontable);
  const [refresh, setRefresh] = useState(false); // Para forzar recarga de datos después de crear/editar
    const [formData, setFormData] = useState({
    tipo: '',
    porcentaje: 0,
    valor: 0,
    name: '',
    status: 'activo'
  });

  console.log('FormData:', formData);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    // Aquí iría la lógica para cargar los impuestos desde la API
    const fetchImpuestos = async () => {
      const data = await getDataList('taxes');
      console.log('Impuestos obtenidos:', data);
      setImpuestos(data.data.data || []);

      // ahora consulto impuestos del sistema contable para mostrar cuáles están configurados
      const impuestosContableData = await listarImpuestosContables();
      console.log('Impuestos del sistema contable:', impuestosContableData);
      setTaxesContable(impuestosContableData.data.impuestos || []);
      setHayImpuestosContable(impuestosContableData.data.ok); // Actualiza el estado según la respuesta del backend
    };
    fetchImpuestos();
  }, [refresh]); // Agrega 'refresh' como dependencia para recargar la lista después de crear/editar

    const handleShowModal = (impuesto = null) => {
    if (impuesto) {
      setFormData(impuesto);
      setEditingId(impuesto._id);
    } else {
      setFormData({
        tipo: '',
        porcentaje: 0,
        valor: 0,
        name: '',
        status: 'activo'
      });
      setEditingId(null);
    }
    setShowModal(true);
  };

    const handleCloseModal = () => setShowModal(false);
    const handleChange = (e) => {

      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });

      // Si el campo que cambió es idContable, autocompleta el resto del formulario con los datos del impuesto contable seleccionado
      if (name === 'idContable') {
        const impuestoSeleccionado = taxescontable.find(tax => tax.idContable === value);
        console.log('Impuesto contable seleccionado:', impuestoSeleccionado);
        if (impuestoSeleccionado) {
          setFormData(prevData => ({
            ...prevData,
            tipo: impuestoSeleccionado.tipo,
            porcentaje: impuestoSeleccionado.porcentaje,
            valor: impuestoSeleccionado.valor,
            name: impuestoSeleccionado.name,
            status: 'activo'
          }));
        }
      }
    };

    const handleSubmit = async (e) => {
    e.preventDefault();
    if (editingId) {
      // Lógica para actualizar un impuesto existente
      await actualizarDatos('taxes', formData,editingId);
    } else {
      // Lógica para crear un nuevo impuesto
      await crearDatos('taxes', formData);
    }
    setShowModal(false);
    setRefresh(!refresh); // Forzar recarga de datos después de crear/editar
  };


    return (
    <div>
      <Card className="mt-3 w-100">
      <Card.Header className='w-100 d-flex justify-content-between align-items-center'>
        {/* Botón para agregar nuevo impuesto va al final al lado derecho y el titulo al lado izquierdo */}
        <h5 className="mb-0">Listado de Impuestos</h5>
         <Button variant="primary" onClick={() => handleShowModal()}>Agregar Impuesto</Button>
      </Card.Header>
      <Card.Body className='w-100'>
      <hr />
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Tipo</th>
            <th>Porcentaje</th>
            <th>Valor</th>
            <th>Nombre</th>
            <th>Status</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {impuestos.map(impuesto => (
            <tr key={impuesto._id}>
              <td>{impuesto.tipo}</td>
              <td>{impuesto.porcentaje}%</td>   
              <td>{impuesto.valor}</td>
              <td>{impuesto.name}</td>
              <td>{impuesto.status}</td>
              <td>  
                <Button variant="warning" onClick={() => handleShowModal(impuesto)}>Editar</Button>
                <Button variant="danger" onClick={() => {/* Lógica para eliminar el impuesto */}}>Eliminar</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>  

        <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
  <Modal.Header closeButton className="bg-dark text-white border-0 px-4 py-3">
    <Modal.Title className="fw-semibold fs-5">
      <i className={`bi ${editingId ? 'bi-pencil-square' : 'bi-plus-circle'} me-2`}></i>
      {editingId ? 'Editar Impuesto' : 'Agregar Impuesto'}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body className="p-4 bg-light">
    <Form onSubmit={handleSubmit}>

      {/* Relación contable */}
      <div className="card border-0 shadow-sm mb-4 rounded-3 w-100">
        <div className="card-header bg-white border-bottom py-3 px-4 w-100">
          <span className="text-muted small fw-semibold text-uppercase ls-1">
            <i className="bi bi-link-45deg me-1"></i> Relación Contable
          </span>
        </div>
        <div className="card-body px-4 py-3 w-100">
          <Form.Group controlId="idContable">
            <Form.Label className="fw-semibold small text-secondary mb-1">
              Impuesto del proveedor contable
            </Form.Label>
            <Form.Select
              name="idContable"
              value={formData.idContable || ''}
              onChange={handleChange}
              className="rounded-2"
            >
              <option value="">— Sin relación —</option>
              {taxescontable.map(tax => (
                <option key={tax._id} value={tax.idContable}>
                  {`${tax.name} — ${tax.porcentaje}%`}
                </option>
              ))}
            </Form.Select>
            {!hayImpuestosContable && (
              <div className="alert alert-warning d-flex align-items-center gap-2 py-2 px-3 mt-2 mb-0 small rounded-2">
                <i className="bi bi-exclamation-triangle-fill"></i>
                No se encontraron impuestos configurados en el sistema contable.
              </div>
            )}
          </Form.Group>
        </div>
      </div>

      {/* Datos del impuesto */}
      <div className="card border-0 shadow-sm rounded-3 w-100">
        <div className="card-header bg-white border-bottom py-3 px-4 w-100">
          <span className="text-muted small fw-semibold text-uppercase">
            <i className="bi bi-receipt me-1"></i> Datos del Impuesto
          </span>
        </div>
        <div className="card-body px-4 py-3 w-100">
          <div className="row g-3">

            <div className="col-md-8">
              <Form.Group controlId="formName">
                <Form.Label className="fw-semibold small text-secondary mb-1">Nombre</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Ej. IVA, Retención en la fuente..."
                  className="rounded-2"
                  required
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group controlId="formPorcentaje">
                <Form.Label className="fw-semibold small text-secondary mb-1">Porcentaje</Form.Label>
                <div className="input-group">
                  <Form.Control
                    type="number"
                    name="porcentaje"
                    value={formData.porcentaje}
                    onChange={handleChange}
                    placeholder="0"
                    className="rounded-start-2"
                    required
                  />
                  <span className="input-group-text rounded-end-2 bg-white text-secondary fw-bold">%</span>
                </div>
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group controlId="formTipo">
                <Form.Label className="fw-semibold small text-secondary mb-1">Tipo</Form.Label>
                <Form.Control
                  type="text"
                  name="tipo"
                  value={formData.tipo}
                  onChange={handleChange}
                  placeholder="Ej. Retencion, IVA..."
                  className="rounded-2"
                  required
                />
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group controlId="formStatus">
                <Form.Label className="fw-semibold small text-secondary mb-1">Estado</Form.Label>
                <Form.Select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  className="rounded-2"
                >
                  <option value="activo">✅ Activo</option>
                  <option value="inactivo">⛔ Inactivo</option>
                </Form.Select>
              </Form.Group>
            </div>

          </div>
        </div>
      </div>

    </Form>
  </Modal.Body>

  <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-end gap-2">
    <Button variant="outline-secondary" onClick={handleCloseModal} className="px-4 rounded-2">
      <i className="bi bi-x-lg me-1"></i> Cancelar
    </Button>
    <Button variant="primary" onClick={handleSubmit} className="px-4 rounded-2">
      <i className={`bi ${editingId ? 'bi-check2-circle' : 'bi-plus-lg'} me-2`}></i>
      {editingId ? 'Actualizar Impuesto' : 'Crear Impuesto'}
    </Button>
    </Modal.Footer>
  </Modal>

      
      
      </Card.Body>
      </Card>
    </div>
  );
}   
